import { ConfigStoreProvider } from '../stores/ConfigStore';
import { BlockStoreProvider } from '../stores/BlockStore';
import Form from './Form';

export default function App({ form = {}, multipleIndex, initialConfig = {} }) {
	return (
		<ConfigStoreProvider
			initialConfig={initialConfig}
			form={form}
			multipleIndex={multipleIndex}
		>
			<BlockStoreProvider initialConfig={initialConfig}>
				<Form />
			</BlockStoreProvider>
		</ConfigStoreProvider>
	);
}
